var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppScreen',{attrs:{"scrollable":_vm.scrollable}},[_c('div',{staticClass:"game-wrapper"},[(!_vm.$route.meta.hideHeader)?_c('GameHeader'):_vm._e(),_c('GameSpace',{ref:"gameSpace"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }